import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KeyValueOpt } from 'src/app/shared/models/keyvalue.model';


@Component({
    selector: 'app-checkbox-list',
    templateUrl: './checkbox-list.component.html',
    styleUrls: ['./checkbox-list.component.scss']
,  standalone: false
})
export class CheckboxListComponent implements OnInit {
    @Input() dataList: KeyValueOpt<string, string, boolean>[] = [];
    @Output() selectedOptions: EventEmitter<KeyValueOpt<string, string, boolean>[]> = new EventEmitter();


    ngOnInit() {
        //This blank function is mandatory.
    }

    selectOption(event,dt:KeyValueOpt<string, string, boolean>) {
        if (event.target.checked) {
            dt.opt = true
        }
        else {
            dt.opt = false
        }
        this.selectedOptions.emit(this.dataList);        
    }

}
